import PropTypes from 'prop-types'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import ChevronLeftIcon from '@mui/icons-material/ChevronLeftRounded'
import ChevronRightIcon from '@mui/icons-material/ChevronRightRounded'
import { useStaticQuery, graphql } from 'gatsby'
import { getImage, GatsbyImage } from 'gatsby-plugin-image'
import { Link, useTranslation } from 'gatsby-plugin-react-i18next'

import { useFormattedDateShort } from 'helpers/formatDate'
import {
  postItemImgWrapperStyle,
  postItemImgBleedStyle,
  postItemImgStyle,
  postItemDateStyle
} from 'common.styles'

import {
  postNavLinkRootStyle,
  postNavLinkInfoStyle,
  postNavLinkTitleStyle,
  postNavLinkDirStyle,
  postNavLinkDirTextStyle
} from './PostNavLink.styles'

function PostNavLink({ post, next }) {
  const { t } = useTranslation()

  const data = useStaticQuery(graphql`
    query {
      allPosts: allMdx {
        nodes {
          fields {
            path
            slug
          }
          frontmatter {
            title
            location
            arrivalDate
            mainImage {
              childImageSharp {
                gatsbyImageData(
                  width: 600,
                  height: 400,
                  quality: 80,
                  transformOptions: { cropFocus: CENTER }
                )
              }
            }
          }
        }
      }
    }
  `)

  if (post) {
    const foundPost = data.allPosts.nodes
      .find(n => n.fields.path === post.fields.path)

    const { title, location, arrivalDate, mainImage } = foundPost.frontmatter

    const arrivalMonth = useFormattedDateShort(arrivalDate)

    const imageProps = {
      image: getImage(mainImage),
      alt: title
    }

    return (
      <Box
        component={Link}
        to={post.fields.slug}
        className={next ? 'next' : undefined}
        sx={postNavLinkRootStyle}
      >
        <Box sx={postItemImgWrapperStyle}>
          <Box className="image-bleed" sx={postItemImgBleedStyle}>
            <GatsbyImage {...imageProps}/>
          </Box>
          <Box
            component={GatsbyImage}
            sx={postItemImgStyle}
            {...imageProps}
          />
        </Box>
        <Box sx={postNavLinkInfoStyle}>
          <Typography
            variant="overline"
            component="div"
            sx={postNavLinkDirStyle}
          >
            {!next ? (
              <>
                <ChevronLeftIcon fontSize="inherit" />
                <Box sx={postNavLinkDirTextStyle}>{t('postNav.prev')}</Box>
              </>
            ) : (
              <>
                <Box sx={postNavLinkDirTextStyle}>{t('postNav.next')}</Box>
                <ChevronRightIcon fontSize="inherit" />
              </>
            )}
          </Typography>
          <Typography variant="body2" sx={postNavLinkTitleStyle}>
            {location}
          </Typography>
          <Typography variant="body2" sx={postItemDateStyle}>
            {arrivalMonth}
          </Typography>
        </Box>
      </Box>
    )
  }

  return <Box sx={postNavLinkRootStyle} />
}

const { bool, string, shape } = PropTypes

PostNavLink.propTypes = {
  post: shape({}),
  next: bool,
  width: string
}

export default PostNavLink
